import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { generateQR } from '../../../utils/qr.util';

@Component({
  selector: 'emc-verify-popup',
  templateUrl: './verify-popup.component.html',
  styleUrl: './verify-popup.component.scss',
  imports: [ButtonModule],
})
export class VerifyPopupComponent {
  receivedData: { userCode: string; verificationUri: string };
  qr: any;

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
  ) {
    this.receivedData = this.config.data;
    this.getUriQR();
  }

  getUriQR() {
    generateQR(this.receivedData.verificationUri).then((url: any) => {
      this.qr = url;
    });
  }

  close() {
    this.ref.close();
  }
}
